var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionsGreenIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6.5H10",
    stroke: "#10A37F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 10.5H7",
    stroke: "#10A37F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4282 18.0719L20.5 11.0001C21.6046 9.89549 21.6046 8.10463 20.5 7.00006C19.3954 5.89549 17.6046 5.89549 16.5 7.00006L9.42819 14.0719C9.14899 14.3511 8.95868 14.7067 8.88124 15.0939L8 19.5001L12.4062 18.6189C12.7934 18.5414 13.149 18.3511 13.4282 18.0719Z",
    stroke: "#10A37F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionsGreenIcon);
export default __webpack_public_path__ + "static/media/TransactionsGreenIcon.d690ba4ce3fa68d30b105b2b12a85026.svg";
export { ForwardRef as ReactComponent };